import { render } from "./AddressExchangeReadModal.vue?vue&type=template&id=5c2e05e9&scoped=true"
import script from "./AddressExchangeReadModal.vue?vue&type=script&lang=js"
export * from "./AddressExchangeReadModal.vue?vue&type=script&lang=js"

import "./AddressExchangeReadModal.vue?vue&type=style&index=0&id=5c2e05e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2e05e9"]])

export default __exports__